'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getOneAppConfig;

var _immutable = require('immutable');

function getOneAppConfig(state) {
  return _immutable.Map.isMap(state) ? state.get('config') : state.config;
}
module.exports = exports['default'];